"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLoading = () => {
    const [state, setState] = (0, react_1.useState)({});
    return {
        is: (key) => state === null || state === void 0 ? void 0 : state[key],
        on: (key) => setState(s => (Object.assign(Object.assign({}, s), { [key]: true }))),
        off: (key) => setState(s => (Object.assign(Object.assign({}, s), { [key]: false }))),
        set: (key, value) => setState(s => (Object.assign(Object.assign({}, s), { [key]: value }))),
    };
};
exports.default = useLoading;
